import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import './assets/css/DropzoneImages.css';
import { v4 as uuidv4 } from 'uuid';

const DropzoneImages = ({ images = [], setImages, handleUploadImages, handleRemoveImage }) => {
    const [isUploading, setIsUploading] = useState(false);

    const onDrop = (acceptedFiles) => {
        const mappedFiles = acceptedFiles.map(file => ({
            file,
            uid: uuidv4(),
            preview: URL.createObjectURL(file),
            isNew: true
        }));

        setImages(prev => Array.isArray(prev) ? [...prev, ...mappedFiles] : [...mappedFiles]);
    };


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { 'image/*': [] },
        multiple: true
    });

    const removeImage = (imgToRemove) => {

        console.log(imgToRemove);

        if (imgToRemove?.isNew && imgToRemove?.preview) {
            URL.revokeObjectURL(imgToRemove.preview);
        }

        if(imgToRemove?.id) {
            handleRemoveImage(imgToRemove?.id);
        }

        setImages(prevImages => {
            return prevImages.filter(img => {
                // 🔁 Se for nova imagem (com uid)
                if (imgToRemove?.uid && img?.uid) {
                    return img.uid !== imgToRemove.uid;
                }

                // ✅ Se for imagem do banco (com id)
                if (imgToRemove?.id && img?.id) {


                    return img.id !== imgToRemove.id;
                }

                // ❌ Se cair aqui, não conseguimos garantir identidade
                return true;
            });
        });

        console.log('Removerrr resultado');
        console.log(images);
    };


    return (
        <>
            <div {...getRootProps()} className="dropzone-box">
                <input {...getInputProps()} />
                <p>{isDragActive ? "Solte aqui..." : "Arraste ou clique para selecionar imagens"}</p>
            </div>

            <div className="preview-thumbs mt-3 d-flex flex-wrap gap-2">
                {Array.isArray(images) && images.map((item, index) => (
                    <div className="thumb" key={item.id || item.uid || index}>
                        <img src={item.preview || item.file} alt={`img-${index}`} className="thumb-img" />
                        <button
                            type="button"
                            className="btn-remove-img"
                            onClick={() => removeImage(images[index])}
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>

            <hr />

            <button
                type="button"
                className="btn btn-success"
                disabled={isUploading || images.length === 0}
                onClick={handleUploadImages}
            >
                {isUploading ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                        Enviando...
                    </>
                ) : (
                    <>
                        <i className="fa fa-upload me-2"></i> Enviar Imagens
                    </>
                )}
            </button>
        </>
    );
};

export default DropzoneImages;
